import type { ComponentProps } from 'react'

import { useFormContext } from 'react-hook-form'

import { ButtonAsync } from '../ButtonAsync'

type Props = {
	allowInvalid?: boolean
} & Omit<ComponentProps<typeof ButtonAsync>, 'onClick' | 'submit'>

export const ButtonSubmit = ({ allowInvalid = true, ...props }: Props) => {
	const { formState } = useFormContext()

	return (
		<ButtonAsync
			{...props}
			disabled={
				props.isLoading ||
				props.disabled ||
				formState.isSubmitting ||
				formState.isLoading ||
				(!allowInvalid && !formState.isValid)
			}
			isLoading={props.isLoading || formState.isSubmitting}
			submit
		/>
	)
}
